import { isEmpty } from 'lodash';
import { TextAttribute } from '../../../team-apis/otterdam/taxonomy';
import { AttributeHelper } from './attribute-helper';

export class TextAttributeHelper extends AttributeHelper<TextAttribute> {
  getLabel(answer: string) {
    return answer;
  }

  getDefaultOptionValue(attribute: TextAttribute) {
    return attribute.defaultValue || '';
  }

  isInvalidValue(value: string, attribute: TextAttribute) {
    return attribute.isRequired && isEmpty(value);
  }
}
